module.exports = __webpack_public_path__ + "img/free-artwork.06dc8e0d.svg";